var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"predictive"}},[_c('br'),_c('PF')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }